import styled from 'styled-components';
import Button from '@mui/material/Button';

export const StyledSelect = styled.select`
	width: 100%;
	height: 50px;
	font-size: 14px;
	line-height: 16px;
	background: #f3f3f3;
	border-radius: 5px;
	padding: 15px;
	border: none;
	font-weight: bold;
	color: #656363;
`;


export const StyledSelectLeft = styled.select`
	width: 50%;
	height: 50px;
	font-size: 14px;
	line-height: 16px;
	background: #f3f3f3;
	border-radius: 5px;
	padding: 15px;
	border: none;
	font-weight: bold;
	color: #656363;
	float:left;
`;

export const StyledSelectRight = styled.select`
	width: 50%;
	height: 50px;
	font-size: 14px;
	line-height: 16px;
	background: #f3f3f3;
	border-radius: 5px;
	padding: 15px;
	border: none;
	font-weight: bold;
	color: #656363;
	float:right;
`;

export const InputContainer = styled.div`
	width: 80%;
	border-style: solid;
	padding: 30px 0px 30px 0px;
	display: flex;
	justify-content: center;
	border-radius: 15px;
	margin: 0px 200px 0px 175px;
	box-shadow: 0px 2px 4px -1px rgba(0,0,0,0.2), 0px 4px 5px 0px rgba(0,0,0,0.14), 0px 1px 10px 0px rgba(0,0,0,0.12);
`;

export const HeaderContainer = styled.div`
	width: 80%;
	border-style: solid;
	padding: 30px 0px 30px 0px;
	display: flex;
	justify-content: Left;
	border-radius: 15px;
	margin: 0px 200px 0px 175px;
	background-color:#333333;
	box-shadow: 0px 2px 4px -1px rgba(0,0,0,0.2), 0px 4px 5px 0px rgba(0,0,0,0.14), 0px 1px 10px 0px rgba(0,0,0,0.12);

	
`;


export const HeaderText = styled.div`
color:white;
font-size:32px;
margin-left:30px;
	
`;


export const NoteField = styled.textarea`
width:100%;
height:200px;
	
`;



export const RedButton = styled.button`
color:white;
background-color:#8B0E04;
border-radius: 15px;
width:125px;
height:50px;
`;


export const GreyButton = styled.button`
color:white;
background-color:#333333;
border-radius: 15px;
width:125px;
height:50px;
`;

export const RightJustifyDiv = styled.div`
justify-content: Right;
display: flex;
`;


export const CenterJustifyDiv = styled.div`
justify-content: Middle;
display: flex;
`;

export const InputWrapper = styled.div`
	padding: 0px 10px 0px 10px;
	width: 80%;
`;

export const SubmitSpan = styled.span`
	color: #333333;
	font-size:18px;
`;

export const divOverflowHidden = styled.div`
overflow:hidden;
`;


export const divFloatLeft = styled.div`
float:left;
width: 50%;
`;

export const divFloatRight = styled.div`
float:right;
width: 50%;
`;

export const styleButtonCalltoaction = 	styled(Button)({
	color: '#fff',
	margin: '10px 0px 0px 0px',
	backgroundColor: '#ff5500',
	fontWeight: 'normal',
	fontSize: '1em',
	textDecoration: 'none',
    //padding: '15px 20px 15px 20px'
    //padding-right: 40px;
    textAlign: 'center',
    border: '2px solid #C4403D',
    fontFamily: 'inherit',
    position: 'relative',
    display: 'inline-block',

	'&:hover': {
		fontWeight: 'bold',
		color: '#fff',
		textDecoration: 'none',
    	borderColor: '#8B0E04',
    	backgroundColor: '#8B0E04'
	},

	'&:focus': {
		fontWeight: 'bold',
		color: '#fff',
		textDecoration: 'none',
    	borderColor: '#8B0E04',
    	backgroundColor: '#8B0E04'
	}

});

    
